/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SyncTOTP
 */
export interface SyncTOTP {
    /**
     * 
     * @type {number}
     * @memberof SyncTOTP
     */
    drift: number;
}

export function SyncTOTPFromJSON(json: any): SyncTOTP {
    return SyncTOTPFromJSONTyped(json, false);
}

export function SyncTOTPFromJSONTyped(json: any, ignoreDiscriminator: boolean): SyncTOTP {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'drift': json['drift'],
    };
}

export function SyncTOTPToJSON(value?: SyncTOTP | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'drift': value.drift,
    };
}


